import { render, staticRenderFns } from "./HotelEdit.vue?vue&type=template&id=10214b5b&scoped=true&"
import script from "./HotelEdit.vue?vue&type=script&lang=js&"
export * from "./HotelEdit.vue?vue&type=script&lang=js&"
import style0 from "./HotelEdit.vue?vue&type=style&index=0&id=10214b5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10214b5b",
  null
  
)

export default component.exports